//   I dont think needs to be a component

import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useState, useEffect, useContext } from "react";
import { v4 } from "uuid";
import { db, storage } from "../utils/firebase";
import SuccessfulProposal from "./SuccessfulProposal";

import { UserContext } from "../functions/UserContext";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function AddProposal() {
  const [isForm, setIsForm] = useState(true);
  const [userLevel, setUserLevel] = useState();
  const [title, setTitle] = useState("");
  const [budget, setBudget] = useState("");
  const [description, setDescription] = useState("");
  const [imageUpload, setImageUpload] = useState(null);
  const [loading, setLoading] = useState(false);
  const [adminEmailList, setAdminEmailList] = useState([]);
  const [newBudget, setNewBudget] = useState(0);
  const [totalFunds, setTotalFunds] = useState(0);
  const [originalTotalFunds, setOriginalTotalFunds] = useState(0);
  const [id, setId] = useState("");
  const [warning, setWarning] = useState("");

  const { user, uid } = useContext(UserContext);

  function generateQuarters(yearsAhead = 1) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentQuarter = Math.floor(currentDate.getMonth() / 3) + 1;

    const quarters = [];

    for (let year = currentYear; year <= currentYear + yearsAhead; year++) {
      for (let quarter = 1; quarter <= 4; quarter++) {
        if (year === currentYear && quarter < currentQuarter) continue;
        quarters.push(`Q${quarter} ${year}`);
      }
    }

    return quarters;
  }

  //TODO: abstract this to a global function
  useEffect(() => {
    //TODO: abstract this to a global function
    // async function getAdminEmailList() {
    //   const q = query(
    //     collection(db, "Users"),
    //     where("userTypeNumber", "==", 4)
    //   );

    //   const adminArray = await getDocs(q);
    //   setAdminEmailList(
    //     adminArray.docs.map((doc) => {
    //       return doc.data().email;
    //     })
    //   );
    // }
    // getAdminEmailList();

    //TODO abstract this to a global function
    async function getBudget() {
      const q = query(
        collection(db, "Communities"),
        where("slug", "==", user.community)
      );
      const communityTotalFunds = await getDocs(q);
      console.log(communityTotalFunds);
      setNewBudget(
        communityTotalFunds.docs[0].data().totalFunds -
          communityTotalFunds.docs[0].data().fundsUsed
      );
      setTotalFunds(communityTotalFunds.docs[0].data().totalFunds);
    }

    getBudget();

    async function getCommunity() {
      const q = query(
        collection(db, "Communities"),
        where("slug", "==", user.community)
      );
      const communityTotalFunds = await getDocs(q);
      setOriginalTotalFunds(communityTotalFunds.docs[0].data().totalFunds);
    }

    getCommunity();
  }, [uid]);

  //TODO: abstract this to a global function
  // async function sendEmail() {
  //   await addDoc(collection(db, "mail"), {
  //     to: adminEmailList,
  //     message: {
  //       subject: `Proposal ${title} has been created`,
  //       html: `
  //         New Proposal Created
  //       `,
  //     },
  //   });
  // }

  const AddProposal = (e) => {
    e.preventDefault();

    try {
      if (title === (undefined || "")) {
        setWarning("Enter Proposal Title");
      } else if (budget === (undefined || "")) {
        setWarning("Enter Budget");
      } else if (newBudget < 0) {
        setWarning("Negative Funds");
      } else if (description === undefined) {
        setWarning("Enter Description");
      }
      // else if (imageUpload === null) {
      //   setWarning("Enter image");
      // }
      else {
        setLoading(true);
        // sendEmail();
        addDoc(collection(db, "Proposals"), {
          title,
          description,
          image: "https://picsum.photos/200/200",
          budget,
          status: "active",
          slug: user.communitySlug,
          community: user.community,
          dateCreated: new Date(),
          endDate: new Date(new Date().setDate(new Date().getDate() + 14)),
          createdBy: uid,
        })
          .then(() => {
            setLoading(false);
            setIsForm(!isForm);
          })
          .then(() => {
            // Query the "Communities" collection to find the document where "name" matches
            const communityQuery = query(
              collection(db, "Communities"),
              where("name", "==", user.community)
            );

            // Execute the query to get matching documents
            getDocs(communityQuery)
              .then((querySnapshot) => {
                console.log("snapshot", querySnapshot);
                querySnapshot.forEach((doc) => {
                  console.log("doc", doc);
                  // Update the found document(s)
                  updateDoc(doc.ref, {
                    // Fields to update
                    fundsUsed: increment(budget),
                  })
                    .then(() => {
                      console.log("Document updated successfully");
                    })
                    .catch((error) => {
                      console.log("Error updating document: ", error);
                    });
                });
              })
              .catch((error) => {
                console.log("Error fetching documents: ", error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateBudget = (e) => {
    const inputValue = e.target.valueAsNumber;

    if (isNaN(inputValue)) {
      setBudget(e.target.value);
      setNewBudget(totalFunds);
    }

    if (!isNaN(inputValue)) {
      setBudget(e.target.value);
      setNewBudget(totalFunds - inputValue);
    }

    console.log("Budget: " + e.target.value);
    console.log("Original Funds:" + originalTotalFunds);

    if (inputValue > 0.8 * originalTotalFunds) {
      setWarning("Budget exceeds 80% of original total funds");
    } else {
      setWarning("");
    }
  };

  return (
    <>
      {isForm ? (
        <form className="login-form mb-5">
          <div className="row">
            <div className="col-12">
              <div className="mb-3">
                <label
                  className="my-1 mr-2"
                  htmlFor="inlineFormCustomSelectPref"
                >
                  Create a Proposal
                </label>
              </div>
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  Proposal Title <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="s"
                  maxLength={100}
                  required
                  placeholder="Enter Proposal Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>
            {/* {userLevel == 4 ? (
              <div className="col-12">
                <div className="mb-3">
                  <label className="form-label small fw-bold">
                    Community <span className="text-danger">*</span>
                  </label>
                  <select name="" id="">
                    <option value="Example">Example</option>
                  </select>
                </div>
              </div>
            ) : null} */}
            <div className="col-12">
              <div className="mb-3">
                <label
                  className="form-label small fw-bold bald"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    Budget <span className="text-danger">*</span>
                  </div>
                  <div>
                    Funds Available:{" "}
                    {newBudget > 0 ? (
                      <span className="text-success">{newBudget}</span>
                    ) : (
                      <span className="text-danger">{newBudget}</span>
                    )}
                  </div>
                </label>
                <input
                  type="number"
                  className="form-control"
                  required
                  placeholder="$"
                  value={budget}
                  onChange={updateBudget}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="mb-3">
                <label className="form-label small fw-bold">
                  Description <span className="text-danger">*</span>
                </label>
                <CKEditor
                  editor={ClassicEditor}
                  data="<p>Please Provide Proposal Details </p>"
                  style={{ height: "500px" }}
                  onInit={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    console.log({ event, editor, data });
                    setDescription(data);
                  }}
                />
              </div>
            </div>

            <div className="col-12">
              <div className="mb-3">
                <label className="form-label small fw-bold">Deadline</label>
                <br />

                <select id="year" className="my-1 mr-sm-2 form-control">
                  {generateQuarters().map((quarter) => (
                    <option key={v4()} value={quarter}>
                      {quarter}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-12">
              <div className="mb-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                    required
                    id="flexCheckDefault"
                  />
                  <label
                    className="form-check-label small fw-bold"
                    htmlFor="flexCheckDefault"
                  >
                    I Accept{" "}
                    <a href="#" className="text-primary">
                      Terms And Condition
                    </a>
                  </label>
                  {loading ? (
                    <>
                      <div style={{ marginLeft: -24 }}>
                        <div
                          className="spinner-border text-primary"
                          style={{ display: "flex", margin: "2em auto" }}
                          role="status"
                        >
                          <span className="visually-hidden">
                            Creating Proposal...
                          </span>
                        </div>
                        <p className="text-center mx-auto">
                          Creating Proposal...
                        </p>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="col-12">
              <button className="btn btn-primary w-100" onClick={AddProposal}>
                Create Proposal
              </button>
            </div>
            <p className="text-danger text-center">{warning}</p>
          </div>
        </form>
      ) : (
        <SuccessfulProposal id={id} community={user.community} />
      )}
    </>
  );
}
